import axios from "../utility/authAxios";
import { API_VERSION } from "../config/axios";

export const trackPrint = async (data) => {
    return axios.post(
        API_VERSION + `/saas-ticketing/counter-panel/print/tracking`,
        data
    );
};
